var a = {
        "name": "Chrome",
        "app": "browser",
        "icon": "chrome",
        "options": {
            "data": {
                "index": "http://v2ex.com"
            },
            "height": 1022.4000000000001,
            "width": 1373.6000000000001
        }
    };

    module.exports = {
        props:{
            app:true
        },
        data: function () {
            return {}
        },
        computed:{
            openedFile:function () {
                var file = this.app.data;
                return $.extend(file._sourceData,{options:file.getOptions()});
            }
        },
        methods: {},
        components: {},
        ready: function () {

        }
    }


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/apps/props.vue
 ** module id = 86
 ** module chunks = 0
 **/